import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="2wj8dpp85co4p">
      <MetaPixel data-id="element-1" data-mp="28u5y0mx2p5cu" />
      <CountdownBar data-id="element-2" data-mp="28tmex2vosax8" />
      <main data-id="element-3" data-mp="28t4lsf4bmctj">
        <Hero data-id="element-4" data-mp="28surifc8tji1" />
        <StatsBar data-id="element-5" data-mp="28sb9kymlev40" />
        <Difference data-id="element-6" data-mp="23vci6nubd29i" />
        <Recognize data-id="element-7" data-mp="23vulg4fe8gqx" />
        <WhatsInside data-id="element-8" data-mp="23ujkecdc1n3i" />
        <InsidePages data-id="element-9" data-mp="23v2sl1d6kx4c" />
        <Bonuses data-id="element-10" data-mp="23ti5fwt74ggi" />
        <Offer data-id="element-11" data-mp="3ik7jmqgv0tve" />
        <Guarantee data-id="element-12" data-mp="3ikqytzf4l45q" />
        <Faq data-id="element-13" data-mp="3ij61k21ff746" />
        <FinalCta data-id="element-14" data-mp="3ijpcuzwkmx98" />
      </main>
      <Footer data-id="element-15" data-mp="3mlj6wpc9h30f" />
    </div>;
}